<template>
  <div>
    <div class="back-btn-container">
      <back-btn />
      <h3 class="title-page">{{ $tc("contractHistory", 0) }}</h3>
    </div>
    <div class="mdm-table">
      <div class="admin_container">
        <table-with-filter
          :height="$vuetify.breakpoint.height - 205"
          fixed-header
          :headers="headers"
          :items="histories"
        >
          <template #filter.contractCode>
            <div class="pa-1">
              <custom-input-text
                @input="getHistoryWithFilter"
                v-model="historyFilter.code"
                clearable
                class="user_input no-margin"
              />
            </div>
          </template>
          <template #filter.numb>
            <div class="pa-1">
              <custom-input-text
                @input="getHistoryWithFilter"
                v-model="historyFilter.itemNumb"
                clearable
                class="user_input no-margin"
              />
            </div>
          </template>
          <template #item.updatedDate="{ item }">{{
            item.updatedAt | fullTimeParse
          }}</template>
          <template #item.updatedByUser="{ item }">
            {{ item.updatedByUser }}
          </template>
          <template #item.contractStatus="{ item }">
            <div :class="{ 'notify-text': item.changes.includes('state') }">
              <span class="notify-text-element">{{
                $t(`contractStatus.${item.state}`)
              }}</span>
            </div>
          </template>
          <template
            #item.initiatorAcceptedCount="{
              /**
               * @type Object
               * @property initiatorAcceptedCount {number}
               */
              item,
            }"
          >
            <div
              :class="{
                'notify-text':
                  item.changes.indexOf('initiatorAcceptedCount') > -1,
              }"
            >
              <span class="notify-text-element">{{
                item.initiatorAcceptedCount
              }}</span>
            </div>
          </template>
          <template #item.unitType="{ item }">{{
            item[`unit_type_name_${$i18n.locale}`]
          }}</template>
          <!--          <template #item.action="{ item, index }">-->
          <!--            &lt;!&ndash;            <v-btn&ndash;&gt;-->
          <!--            &lt;!&ndash;              v-if="index !== 0 && $can($permissions['RESTORE'])"&ndash;&gt;-->
          <!--            &lt;!&ndash;              class="new_style"&ndash;&gt;-->
          <!--            &lt;!&ndash;              @click="onRestore(index)"&ndash;&gt;-->
          <!--            &lt;!&ndash;            >&ndash;&gt;-->
          <!--            &lt;!&ndash;              <vue-icon icon="newTimeIcon"></vue-icon>&ndash;&gt;-->
          <!--            &lt;!&ndash;            </v-btn>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <v-btn&ndash;&gt;-->
          <!--            &lt;!&ndash;              class="new_style"&ndash;&gt;-->
          <!--            &lt;!&ndash;              v-if="item.signed"&ndash;&gt;-->
          <!--            &lt;!&ndash;              @click="showHistorySigned(item)"&ndash;&gt;-->
          <!--            &lt;!&ndash;            >&ndash;&gt;-->
          <!--            &lt;!&ndash;              <vue-icon icon="newFileEdit"></vue-icon>&ndash;&gt;-->
          <!--            &lt;!&ndash;            </v-btn>&ndash;&gt;-->
          <!--          </template>-->
        </table-with-filter>
      </div>
      <warning-dialog
        @apply="PrevChangeContract"
        @cancel="selectedHistoryIndex = null"
        v-model="warningDialog"
        description="doYouWantGoBack"
        yes-text="yes"
      ></warning-dialog>
      <signed-info-dialog ref="signedInfoDialog"></signed-info-dialog>
    </div>
  </div>
</template>

<script>
import { debounce, getQueryByKey } from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import { contractItemStatus, SIGNED_USER_DATA_TYPE } from "@/utils/constants";
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import SignedInfoDialog from "@/components/history/SignedInfoDialog.vue";

export default {
  data() {
    return {
      selectedHistoryIndex: null,
      warningDialog: false,
      isShowFilter: false,
      historyFilter: {
        code: null,
        fromDate: null,
        toDate: null,
        supplierId: null,
        contractCurrentStatus: null,
        itemNumb: null,
      },
      histories: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("contractNumber"),
          value: "contractCode",
        },
        {
          text: this.$t("numberPositionInContract"),
          value: "numb",
        },
        {
          text: this.$t("product"),
          value: "productName",
        },
        {
          text: this.$t("count"),
          value: "count",
        },
        // {
        //   text: this.$t("unit"),
        //   value: "unitType",
        // },
        {
          text: this.$t("status"),
          value: "contractStatus",
        },
        // {
        //   text: this.$t("acceptedCount"),
        //   value: "initiatorAcceptedCount",
        // },
        {
          text: this.$t("updatedByUser"),
          value: "updatedByUser",
        },
        {
          text: this.$t("updatedDate"),
          value: "updatedDate",
        },
        // {
        //   text: this.$t("action"),
        //   value: "action",
        // },
      ];
    },
    contractItemStatus() {
      return Object.keys(contractItemStatus).map((item) => {
        return {
          text: this.$t(`contractStatus.${item}`),
          value: item,
        };
      });
    },
  },
  methods: {
    onRestore(index) {
      this.selectedHistoryIndex = index;
      this.warningDialog = true;
    },
    async showHistorySigned(item) {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("history/signed-user", {
          params: {
            dataType: SIGNED_USER_DATA_TYPE.ContractItem,
            id: item.id,
            revision: item.revision,
          },
        });
        const { signedInfoDialog } = this.$refs;
        signedInfoDialog.open(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async PrevChangeContract() {
      this.showLoading();
      try {
        await this.$http.post("backend/previous-changes-contract-item", {
          objectId: this.histories[this.selectedHistoryIndex].id,
          revision: this.histories[this.selectedHistoryIndex].revision,
        });
        await this.getHistories();
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },

    getHistoryWithFilter: debounce(function () {
      const query = this.historyFilter;
      this.$router.replace({ query }).catch((err) => {
        this.setResponseError({ error: err });
      });
      this.getHistoryWithLoading();
    }, 400),

    async getHistories() {
      const params = { ...this.historyFilter };
      try {
        const {
          data: { data },
        } = await this.$http.get("history/office/contract-items", {
          params,
        });
        this.histories = data;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getHistoryWithLoading() {
      this.showLoading();
      await this.getHistories();
      this.clearLoading();
    },
  },
  components: {
    SignedInfoDialog,
    WarningDialog,
    TableWithFilter,
    BackBtn,
  },
  async created() {
    this.historyFilter = getQueryByKey(this.historyFilter, this.$route.query);
    this.showLoading();
    await this.getHistories();
    this.clearLoading();
  },
};
</script>
